/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseSuccess
 */
export interface ResponseSuccess {
    /**
     * 
     * @type {object}
     * @memberof ResponseSuccess
     */
    data: object;
    /**
     * 
     * @type {object}
     * @memberof ResponseSuccess
     */
    meta: object;
}

/**
 * Check if a given object implements the ResponseSuccess interface.
 */
export function instanceOfResponseSuccess(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function ResponseSuccessFromJSON(json: any): ResponseSuccess {
    return ResponseSuccessFromJSONTyped(json, false);
}

export function ResponseSuccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSuccess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
        'meta': json['meta'],
    };
}

export function ResponseSuccessToJSON(value?: ResponseSuccess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'meta': value.meta,
    };
}

